import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';
import { Twitter, Email, Chat, Favorite } from '@mui/icons-material';
import styled from 'styled-components';
import { useLanguage } from '../../contexts/LanguageContext';
import LiveDot from '../common/LiveDot/LiveDot';

const StyledFooter = styled(Box)`
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 4rem 0 2rem;
  margin-top: auto;
  box-shadow: 0 -1px 10px rgba(0, 0, 0, 0.05);
`;

const SocialIcon = styled(Link)`
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: 0 1rem;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  &:first-child {
    margin-left: 0;
  }
`;

const LogoContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <StyledFooter>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <LogoContainer>
              {/* <LiveDot /> */}
              <Typography variant="h6" color="primary">
                XCH.live
              </Typography>
            </LogoContainer>
            <Typography variant="body2" color="textSecondary" paragraph>
              {t('footer.description')}
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t('footer.quickLinks')}
            </Typography>
            <Box component="nav">
              <Link href="/about" color="textSecondary" display="block" mb={1}>
                {t('footer.about')}
              </Link>
              <Link href="/terms" color="textSecondary" display="block" mb={1}>
                {t('footer.terms')}
              </Link>
              <Link href="/privacy" color="textSecondary" display="block" mb={1}>
                {t('footer.privacy')}
              </Link>
              <Link href="/contact" color="textSecondary" display="block">
                {t('footer.contact')}
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {t('footer.connectWithUs')}
            </Typography>
            <Box mb={2}>
              <SocialIcon href="https://x.com/xchlive" target="_blank">
                <Twitter />
              </SocialIcon>
              <SocialIcon href="https://discord.com/invite/Bb4sj3Bg9P" target="_blank">
                <Chat />
              </SocialIcon>
              <SocialIcon href="mailto:hello@xch.live">
                <Email />
              </SocialIcon>
            </Box>
            <Typography variant="body2" color="textSecondary">
              {t('footer.copyright')}
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
              {t('footer.builtBy')}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </StyledFooter>
  );
};

export default Footer; 